import { combineReducers } from "@reduxjs/toolkit";
import suggestions from "./suggestions";
import experiments from "./experiments";

const mainReducer = combineReducers({
  suggestions,
  experiments
});

export type RootState = ReturnType<typeof mainReducer>;

export default mainReducer;
